/** 把 id 对应的条目挪到目标位置，后面的条目依次让位；原位、越界或 id 不存在时原样返回。 */
export function moveItem<T extends { id: string }>(
  items: T[],
  id: string,
  toIndex: number,
): T[] {
  const fromIndex = items.findIndex((item) => item.id === id);

  if (
    fromIndex < 0 ||
    toIndex === fromIndex ||
    toIndex < 0 ||
    toIndex >= items.length
  ) {
    return items;
  }

  const copy = [...items];
  const [moving] = copy.splice(fromIndex, 1);

  if (moving === undefined) {
    return items;
  }

  copy.splice(toIndex, 0, moving);
  return copy;
}
